import { STORY_OCCASIONS, type UnifiedStoryTemplate } from '@/lib/unified-story-templates';

export interface TemplateGroup { key: string; label: string; templates: UnifiedStoryTemplate[] }

/**
 * Groups for the story step.
 * - Occasion-first: one group per occasion, in STORY_OCCASIONS order (empty ones dropped), then every
 *   other template under "More adventures".
 * - Otherwise: one flat group, which is today's grid.
 */
export function groupTemplatesForPicker(templates: UnifiedStoryTemplate[], occasionFirst: boolean): TemplateGroup[] {
  if (!occasionFirst) return [{ key: 'all', label: 'All stories', templates }];
  const groups: TemplateGroup[] = STORY_OCCASIONS
    .map((o) => ({ key: o.id, label: o.label, templates: templates.filter((t) => t.occasion === o.id) }))
    .filter((g) => g.templates.length > 0);
  const rest = templates.filter((t) => !t.occasion);
  if (rest.length > 0) groups.push({ key: 'more', label: 'More adventures', templates: rest });
  return groups;
}
